export default "/images/c9458b2d0bbdbb70d97700812f36c67e.avif";